import {
    LOG_IN,
    LOG_OUT,
    LOG_OUT_SUCCESS,
    LOG_IN_FAIL,
    CHECK_SESSION,
    CHECK_SESSION_SUCCESS,
    CHECK_SESSION_FAIL,
    LOAD_USER_PROFILE,
    LOAD_USER_PROFILE_SUCCESS,
    LOAD_USER_PROFILE_FAILURE,
    UPDATE_USER_PROFILE,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAILURE,
    OPEN_USER_PROFILE_DIALOG,
    CLOSE_USER_PROFILE_DIALOG,
    START_HEARTBEAT,
    SHOW_SESSION_WARNING,
    HIDE_SESSION_WARNING,
    EXTEND_SESSION,
    EXTEND_SESSION_FAILURE,
} from './SessionActionTypes';
import {errorMessage} from "../../../components/AjaxHelpers";


// Check if user has active session (called on app load)
export const checkSession = () => ({
    type: CHECK_SESSION,
})

export const checkSessionSuccess = (userInfo) => ({
    type: CHECK_SESSION_SUCCESS,
    userInfo,
})

export const checkSessionFail = () => ({
    type: CHECK_SESSION_FAIL,
})

// Login: Triggers redirect to /oauth2/authorization/keycloak
export const logIn = () => ({
    type: LOG_IN,
})

// Logout: Triggers redirect to /logout
export const logOut = () => ({
    type: LOG_OUT,
})

export const logOutSucceeded = (username, reason) => ({
    type: LOG_OUT_SUCCESS,
    username,
    reason,
})

export const logInFailed = (error) => ({
    type: LOG_IN_FAIL,
    error
})


export const loadUserProfile = () => ({
    type: LOAD_USER_PROFILE,
})

export const loadUserProfileSucceeded = (userProfile) => ({
    type: LOAD_USER_PROFILE_SUCCESS,
    userProfile,
})

export const loadUserProfileFailed = (error) => ({
    type: LOAD_USER_PROFILE_FAILURE,
    message: errorMessage(error, 'Fel vid laddning av användarprofil'),
})

export const updateUserProfile = (userProfile) => ({
    type: UPDATE_USER_PROFILE,
    userProfile,
})

export const updateUserProfileSucceeded = () => ({
    type: UPDATE_USER_PROFILE_SUCCESS,
})

export const updateUserProfileFailed = (error) => ({
    type: UPDATE_USER_PROFILE_FAILURE,
    message: errorMessage(error, 'Fel vid uppdatering av användarprofil'),
})

export const openUserProfileDialog = () => ({
    type: OPEN_USER_PROFILE_DIALOG,
})

export const closeUserProfileDialog = () => ({
    type: CLOSE_USER_PROFILE_DIALOG,
})

export const startHeartbeat = () => ({
    type: START_HEARTBEAT,
})

export const showSessionWarning = () => ({
    type: SHOW_SESSION_WARNING,
})

export const hideSessionWarning = () => ({
    type: HIDE_SESSION_WARNING,
})

export const extendSession = () => ({
    type: EXTEND_SESSION,
})

export const extendSessionFailed = () => ({
    type: EXTEND_SESSION_FAILURE,
})
